import React, { useState, useEffect } from 'react';
import { TennisBall } from '@phosphor-icons/react';

/**
 * Reusable avatar component. Displays:
 *   - the user's uploaded photo from `src` if present and loads successfully
 *   - a tennis-ball style fallback otherwise
 *
 * Sizes: 'sm' | 'md' | 'lg' | 'xl' (40 / 56 / 80 / 112 px)
 */
const SIZE_MAP = {
  sm: { box: 'w-10 h-10', icon: 18, text: 'text-sm' },
  md: { box: 'w-14 h-14', icon: 24, text: 'text-base' },
  lg: { box: 'w-20 h-20', icon: 36, text: 'text-2xl' },
  xl: { box: 'w-28 h-28', icon: 48, text: 'text-3xl' },
};

export default function Avatar({
  src,
  name = '',
  size = 'md',
  ring = false,
  className = '',
  testId,
}) {
  const [errored, setErrored] = useState(false);
  useEffect(() => { setErrored(false); }, [src]);

  const cfg = SIZE_MAP[size] || SIZE_MAP.md;
  const initial = (name || '').trim().charAt(0).toUpperCase();
  const ringClass = ring ? 'ring-2 ring-[#c2a251]/40' : '';

  return (
    <div
      data-testid={testId}
      className={`${cfg.box} rounded-full overflow-hidden flex items-center justify-center shrink-0 bg-[#f0ece3] border border-[#e3dcd1] ${ringClass} ${className}`}
    >
      {src && !errored ? (
        <img
          src={src}
          alt={name}
          onError={() => setErrored(true)}
          className="w-full h-full object-cover"
        />
      ) : initial ? (
        <span className={`font-serif font-semibold text-[#013523] ${cfg.text}`}>{initial}</span>
      ) : (
        <TennisBall size={cfg.icon} weight="duotone" className="text-[#c2a251]" />
      )}
    </div>
  );
}
